import OtherGreenhouseDeleteButton from './OtherGreenhouseDeleteButton';
import OtherGreenhouseEditButton from './OtherGreenhouseEditButton';

type OtherGreenhouseActionsProp = { rowId: number | string };

const OtherGreenhouseActions = ({ rowId }: OtherGreenhouseActionsProp) => {
  return (
    <>
      <OtherGreenhouseEditButton rowId={rowId} />
      <OtherGreenhouseDeleteButton rowId={rowId} />
    </>
  );
};

export default OtherGreenhouseActions;
